module.exports = __webpack_public_path__ + "assets/images/project/people/boy-chart.png?v=e352e8b2";